// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основной контейнер страницы */
.users-page-container {
    font-family: 'Arial', sans-serif;

    padding: 40px 20px;
}

/* Основной блок с содержимым */
.users-main-block {
    max-width: 1000px;
    margin: 0 auto;
    /* background-color: #ffffff;*/
    border-radius: 8px;
    /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);*/
    padding: 30px;
}

/* Заголовок */
h2 {
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    color: #333;
}

/* Кнопка добавления пользователя */
.users-addButton {
    background-color: #007bff;
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    text-align: center;
    display: block;
    margin: 0 auto 30px auto;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.users-addButton:hover {
    background-color: #0056b3;
}

/* Контейнер для карт пользователей */
.users-cardsContainer {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

/* Карта пользователя */
.users-card {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.users-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

/* Заголовок и информация карты */
.users-cardHeader {
    margin-bottom: 10px;
}

.users-cardHeader h3 {
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

.users-username {
    font-size: 14px;
    color: #777;
}

.users-cardBody p {
    font-size: 14px;
    color: #555;
}

/* Кнопки действий */
.users-cardFooter {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}

.users-editButton, .users-deleteButton {
    padding: 8px 15px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    width: 48%;
}

.users-editButton {
    background-color: #28a745;
    color: white;
}

.users-editButton:hover {
    background-color: #218838;
}

.users-deleteButton {
    background-color: #dc3545;
    color: white;
}

.users-deleteButton:hover {
    background-color: #c82333;
}

/* Адаптивные стили */
@media (max-width: 768px) {
    .users-main-block {
        padding: 20px;
    }

    .users-addButton {
        font-size: 14px;
    }

    .users-cardsContainer {
        grid-template-columns: 1fr;
    }
}




`, "",{"version":3,"sources":["webpack://./src/modules/Admin/components/UserList.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,gCAAgC;;IAEhC,kBAAkB;AACtB;;AAEA,+BAA+B;AAC/B;IACI,iBAAiB;IACjB,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,8CAA8C;IAC9C,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,iCAAiC;AACjC;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Основной контейнер страницы */\r\n.users-page-container {\r\n    font-family: 'Arial', sans-serif;\r\n\r\n    padding: 40px 20px;\r\n}\r\n\r\n/* Основной блок с содержимым */\r\n.users-main-block {\r\n    max-width: 1000px;\r\n    margin: 0 auto;\r\n    /* background-color: #ffffff;*/\r\n    border-radius: 8px;\r\n    /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);*/\r\n    padding: 30px;\r\n}\r\n\r\n/* Заголовок */\r\nh2 {\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    color: #333;\r\n}\r\n\r\n/* Кнопка добавления пользователя */\r\n.users-addButton {\r\n    background-color: #007bff;\r\n    color: white;\r\n    padding: 12px 20px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 16px;\r\n    text-align: center;\r\n    display: block;\r\n    margin: 0 auto 30px auto;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.users-addButton:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n/* Контейнер для карт пользователей */\r\n.users-cardsContainer {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n}\r\n\r\n/* Карта пользователя */\r\n.users-card {\r\n    background-color: #ffffff;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.users-card:hover {\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Заголовок и информация карты */\r\n.users-cardHeader {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.users-cardHeader h3 {\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n    color: #333;\r\n}\r\n\r\n.users-username {\r\n    font-size: 14px;\r\n    color: #777;\r\n}\r\n\r\n.users-cardBody p {\r\n    font-size: 14px;\r\n    color: #555;\r\n}\r\n\r\n/* Кнопки действий */\r\n.users-cardFooter {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n}\r\n\r\n.users-editButton, .users-deleteButton {\r\n    padding: 8px 15px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    width: 48%;\r\n}\r\n\r\n.users-editButton {\r\n    background-color: #28a745;\r\n    color: white;\r\n}\r\n\r\n.users-editButton:hover {\r\n    background-color: #218838;\r\n}\r\n\r\n.users-deleteButton {\r\n    background-color: #dc3545;\r\n    color: white;\r\n}\r\n\r\n.users-deleteButton:hover {\r\n    background-color: #c82333;\r\n}\r\n\r\n/* Адаптивные стили */\r\n@media (max-width: 768px) {\r\n    .users-main-block {\r\n        padding: 20px;\r\n    }\r\n\r\n    .users-addButton {\r\n        font-size: 14px;\r\n    }\r\n\r\n    .users-cardsContainer {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
